export default __webpack_public_path__ + "static/media/THSarabun Italic.bfa345b7.ttf";